import { createSlice } from "@reduxjs/toolkit";

const language=createSlice({
  name:"language",
  initialState:{lg:'zh'},
  reducers:{
    setLanguageS:(state,action)=>{
      state.lg=action.payload
    }
  }
});

export const {setLanguageS}=language.actions
export default language.reducer